module.exports = __webpack_public_path__ + "img/IBANK.266b40d0.png";